export { default } from "./GuidedHighlightingTeacherSkillQuestion";
